module.exports = __webpack_public_path__ + "img/1_no.35dbb56a.svg";